import { render, staticRenderFns } from "./dataRanking.vue?vue&type=template&id=633ab574&scoped=true&"
import script from "./dataRanking.vue?vue&type=script&lang=js&"
export * from "./dataRanking.vue?vue&type=script&lang=js&"
import style0 from "./dataRanking.vue?vue&type=style&index=0&id=633ab574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ab574",
  null
  
)

export default component.exports